import { Text } from '@doordash/design-language'
import * as React from 'react'

import t from './strings'

const ScheduleOrientationFormHeader = () => (
  <React.Fragment>
    <Text styles={Text.Styles.Bold24} color={Text.Colors.TextAction}>
      {t.headerH1()}
    </Text>
    <Text styles={Text.Styles.PageSubtext}>{t.headerText()}</Text>
  </React.Fragment>
)

export default ScheduleOrientationFormHeader
